<template>
  <div class="content-and-image">
    <div class="question">
      <div class="title-in-bg" v-if="question.settings.questionDisplayStyle == 1" v-bind:style="question.media != null ? {backgroundImage: 'url('+question.media.value.src+')',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'} : {backgroundColor: question.settings.questionBackgroundColor}">
        <p :style="{color: question.settings.questionFontColor}">{{question.text}}</p>
      </div>
      <div class="title-out-bg" v-else-if="question.settings.questionDisplayStyle == 2">
        <p :style="{color: question.settings.questionFontColor}">{{question.text}}</p>
        <div class="img-question" v-if="question.media != null">
          <img :src="question.media.value.src" />
        </div>
      </div>
      <div class="title-only-image" v-else-if="question.settings.questionDisplayStyle == 3">
          <div class="img-question" v-if="question.media != null">
            <img :src="question.media.value.src" />
          </div>
      </div>
      <div class="title-only-text" v-else>
          <p :style="{color: question.settings.questionFontColor}">{{question.text}}</p>
      </div>

      <div class="wrap-answer" v-bind:class="['answer_'+ question.settings.optionDisplayColumn,answer[index].num == question.answers.length ? 'disable' : '']" >
        <div 
          class="answer" 
          v-for="(value,key) in question.options" 
          v-bind:key="key"
          v-bind:class="[
            (answer[index].data.length > 0 && answer[index].data.includes(value.id) && question.answers.includes(value.id) || answer[index].num == question.answers.length && question.answers.includes(value.id)) ? 'correct' : '',
            answer[index].data.length > 0 && answer[index].data.includes(value.id) && !question.answers.includes(value.id) ? 'in-correct' : ''
          ]"
          @click="selectAnswer(question, value.id)"
        >
          <div class="answer-img" :style="{backgroundColor: value.settings.backgroundColor != '' ? value.settings.backgroundColor : question.settings.optionBackgroundColor}">
            <div class="img" v-if="value.media != null">
              <img :src="value.media.value.src" />
            </div>
            <div class="text" :style="{color: value.settings.fontColor != '' ? value.settings.fontColor : question.settings.optionFontColor, overflowWrap: 'anywhere'}">{{value.text}}</div>
          </div>
          <div class="icon-correct" v-if="question.answers.includes(value.id)" >
            <Correct />
          </div>
          <div class="icon-in-correct" v-if="!question.answers.includes(value.id)">
            <InCorrect />
          </div>
        </div>
      </div>
      <div v-if="showResult">
        <div v-if="answer[index].correct == 1" class="show-correct">
          <div class="info">
            <div class="icon">
              <Correct />
            </div>
            <span>Chính xác</span>
          </div>
          <div class="description" v-if="question.correct_note.text != ''" v-html="question.correct_note.text" />
          <div class="image-question" v-if="question.correct_note.media != null">
            <img :src="question.correct_note.media.value.src" />
          </div>
        </div>
        <div v-if="answer[index].correct == 0" class="show-in-correct">
          <div class="info">
            <div class="icon">
              <InCorrect />
            </div>
            <span>Không chính xác</span>
          </div>
          <div class="description" v-if="question.correct_note.text != ''" v-html="question.correct_note.text" />
          <div class="image-question" v-if="question.correct_note.media != null">
            <img :src="question.correct_note.media.value.src" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InCorrect from '../../ui/icons/svgs/icons/InCorrect'
import Correct from '../../ui/icons/svgs/icons/Correct'
export default {  
  name: "ContentAndImage",
  props: ['question', 'index', 'showResult'],
  components: {
    InCorrect,
    Correct
  },
  computed: {
    answer: function(){
      return this.$store.getters.defaultAnswer
    }
  },
  methods: {
    selectAnswer(question, option_id){
      const infoOption = [question.id,option_id, question.kind]
      this.$store.dispatch('chooseAnswer', infoOption);
    }
  }
};
</script>

<style lang="scss">
  .content-and-image{
    .title-in-bg{
      display: flex;
      align-items: center;
      border-radius: 8px;
      font-weight: bold;
      min-height: 116px;
      font-size: 32px;
      line-height: 36px;
      justify-content: center;
      text-align: center;
      padding: 44px 60px;
      color: #FFFFFF;
    }
    .title-out-bg{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      border-radius: 8px;
      font-weight: bold;
      margin-bottom: 10px;
      color: #333333;
      justify-content: left;
      text-align: left;
      font-size: 26px;
      line-height: 31px;
      .img-question{
        width: 100%;
        margin-top: 10px;
        img{
          width: 100%;
          border-radius: 8px;
        }
      }
    }
    .title-only-image{
      width: 100%;
      .img-question{
        width: 100%;
        img{
          width: 100%;
          border-radius: 8px;
        }
      }
    }
    .title-only-text{
      p{
        font-weight: bold;
        font-size: 26px;
        line-height: 31px;
      }
    }
    .wrap-answer{
      display: grid;
      justify-content: space-between;
      grid-gap: 10px;
      .answer{
        cursor: pointer;
        position: relative;
        border-radius: 13px;
		margin-top: 10px;
		height: 100%;

        .answer-img{
		  border-radius: 12px;
		  height: 100%;

          .img{
              width: 100%;
            //   height: 100%;
              padding-top: 65%;
              position: relative;
              img{
                  width: 100%;
                  height: 100%;
                  border-top-left-radius: 8px;
                  border-top-right-radius: 8px;
                  position: absolute;
                  top: 0;
                  left: 0;
                  object-fit: cover;
              }
          }
          .text{
            min-height: 44px;
            padding: 8px 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            font-weight: bold;
            font-size: 18px;
            line-height: 18px;
          }
        }
        .icon-correct{
          background: #24A148;
          width: 24px;
          height: 24px;
          position: absolute;
          top: 10px;
          right: 10px;
          border-radius: 50%;
          display: none;
          align-items: center;
          justify-content: center;
          svg{
            width: 10px;
            fill: #fff;
          }
        }
        .icon-in-correct{
          background: #DA1E28;
          width: 24px;
          height: 24px;
          position: absolute;
          top: 10px;
          right: 10px;
          border-radius: 50%;
          display: none;
          align-items: center;
          justify-content: center;
          svg{
            width: 10px;
            fill: #fff;
          }
        }
      }
      .correct{
        .answer-text{
            border: 3px solid green;
        }
        .answer-img{
            border: 3px solid green;
        }
        .icon-correct{
            display: flex;
        }
      }
      .in-correct{
        .answer-text{
            border: 3px solid #DA1E28;
        }
        .answer-img{
            border: 3px solid #DA1E28;
        }
        .icon-in-correct{
            display: flex;
        }
      }
    }
    .answer_4{
      grid-template-columns: repeat(2, 1fr);
      @media only screen and (min-width: 500px) {
        grid-template-columns: repeat(4, 1fr);
      }
    }
    .answer_3{
      grid-template-columns: repeat(3, 1fr);
    }
    .answer_2{
      grid-template-columns: repeat(2, 1fr);
    }
    .answer_1{
      grid-template-columns: repeat(1, 1fr);
      width: 100%;
      border-radius: 8px;
      .answer{
        .answer-text{
          // height: calc(100% - 6px);
          // width: calc(100% - 6px);
          margin: auto;
          min-height: unset;
          padding: 9px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 16px;
          line-height: 20px;
          text-align: center;
        }
      }
    }
    .show-correct{
      margin-top: 24px;
      padding: 16px;
      background: rgba(36, 161, 72, 0.05);
      border-radius: 8px;
      .info{
        display: flex;
        align-items: center;
        .icon{
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: #24A148;
          display: flex;
          align-items: center;
          justify-content: center;
          svg{
            fill: #fff;
            width: 20px;
          }
        }
        span{
          font-weight: bold;
          font-size: 18px;
          line-height: 20px;
          color: #333333;
          margin-left: 12px;
        }
      }
      .description{
        font-size: 16px;
        line-height: 19px;
        color: #666666;
        margin: 16px 0;
      }
      .image-question{
        margin-top: 16px;
        width: 300px;
        // height: 160px;
        margin: auto;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .show-in-correct{
      margin-top: 24px;
      padding: 16px;
      background: linear-gradient(0deg, rgba(218, 30, 40, 0.05), rgba(218, 30, 40, 0.05)), #FFFFFF;
      border-radius: 8px;
      .info{
        display: flex;
        align-items: center;
        .icon{
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: #DA1E28;
          display: flex;
          align-items: center;
          justify-content: center;
          svg{
            fill: #fff;
            width: 20px;
          }
        }
        span{
          font-weight: bold;
          font-size: 18px;
          line-height: 20px;
          color: #333333;
          margin-left: 12px;
        }
      }
      .description{
        font-size: 16px;
        line-height: 19px;
        color: #666666;
        margin: 16px 0;
      }
      .image-question{
        margin-top: 16px;
        width: 300px;
        // height: 160px;
        margin: auto;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .disable{
      pointer-events: none;
    }
  }
  @media screen and (max-width: 768px) {
    .content-and-image .title-only-text p {
      font-size: 6vw;
      line-height: 130%;
    }
    .content-and-image .title-in-bg {
      font-size: 6vw;
      line-height: 130%;
      padding: 20px;
    }
  }
</style>
